import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const defaultLabSettings: LabSettings = {
  filterStructure: 'legacy',
};

const defaultEditorOptions: EditorOptions = {
  mapviewGridSnap: true,
};

const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      // Initial State
      userPhoneNumber: '',
      merchantKioskVersion: 1,
      merchantData: {},
      loading: false,
      kioskOptions: [],
      kioskOptionsLoadedMerchantId: null,
      labSettings: defaultLabSettings,
      options: defaultEditorOptions,

      // Actions
      setUserPhoneNumber: (phone) => set({ userPhoneNumber: phone }),
      setMerchantKioskVersion: (version) => set({ merchantKioskVersion: version }),
      setMerchantData: (data) => set({ merchantData: data }),
      setLoading: (loading) => set({ loading }),
      setKioskOptions: (options) => set({ kioskOptions: options }),
      setKioskOptionsLoadedMerchantId: (id) => set({ kioskOptionsLoadedMerchantId: id }),
      setLabSettings: (settings) =>
        set((state) => ({
          labSettings: { ...state.labSettings, ...settings },
        })),
      setOptions: (options) =>
        set((state) => ({
          options: { ...state.options, ...options },
        })),
      reset: () =>
        set({
          userPhoneNumber: '',
          merchantKioskVersion: 1,
          merchantData: {},
          loading: false,
          kioskOptions: [],
          kioskOptionsLoadedMerchantId: null,
          labSettings: defaultLabSettings,
          options: defaultEditorOptions,
        }),
    }),
    {
      name: 'app-storage',
      partialize: (state) => ({
        userPhoneNumber: state.userPhoneNumber,
        merchantKioskVersion: state.merchantKioskVersion,
        merchantData: state.merchantData,
        loading: state.loading,
        kioskOptions: state.kioskOptions,
        labSettings: state.labSettings,
        options: state.options,
        // kioskOptionsLoadedMerchantId는 persist하지 않음 (기존 Recoil과 동일)
      }),
    }
  )
);

export default useAppStore;
